<div class="bg-primary-gradient container-fluid text-white d-flex flex-column flex-grow-1 overflow-scroll h-100">
  <div class="my-3 text-center d-none d-md-block d-lg-block">
    <h3 class="m-0 p-0" translate>Referral Program</h3>
  </div>
  <div class="row d-flex justify-content-center flex-grow-1">
    <div class="col-md-8 col-lg-6 col-sm-12">
      <h4 translate>Free membership renewal</h4>
      <p class="small" translate>
        Help IKO build a safer and more knowledgeable community for kiters. Refer 10 people to the premium Kiter
        Membership and get your own instructor membership renewed instantly.
      </p>
      <h4 translate>How-to-Steps</h4>
      <p class="small">
        <span class="fw-bold me-1">1-</span
        ><span translate>Share your referral link with 10 friends and/or students</span>
      </p>
      <p class="small">
        <span class="fw-bold me-1">2-</span><span translate>They get 10% off when upgrading to the Premium plan</span>
      </p>
      <p class="small">
        <span class="fw-bold me-1">3-</span><span translate>You get one more year to your current instructor plan</span>
      </p>
    </div>
  </div>
  <div class="row me-sm-3 ms-n5 d-flex justify-content-center flex-grow-1">
    <div class="row col-md-8 col-lg-6 col-sm-12">
      <div class="col-sm-3 col-6 text-center position-relative mt-3" *ngFor="let profile of profiles">
        <div class="profile-picture position-relative mx-auto p-sm-3">
          <image-srcset
            [width]="80"
            [height]="80"
            *ngIf="profile.profile_image"
            [item]="profile.profile_image"
            imgClass="box-shadow rounded-circle h-100 w-100"
          >
          </image-srcset>
          <div
            *ngIf="!profile.profile_image"
            class="text-info profile-picture-image box-shadow rounded-circle w-100 h-100"
          >
            <img
              src="/assets/images/blank-profile.png"
              class="rounded-circle"
              [alt]="'blank-profile-' + profile.first_name"
            />
          </div>
          <div class="position-absolute m-auto tb-0 lr-0 d-flex justify-content-center p-sm-3 lr-md-0">
            <div
              class="profile-gradient"
              [ngClass]="{
                'rounded-circle border border-secondary': profile.affiliation_status === 1,
              }"
            ></div>
          </div>
        </div>
        <div class="bottom-1 lr-0 h-25">
          <div class="mt-md-4 mt-sm-3">
            {{ profile.first_name }}
          </div>
          <div>{{ profile.last_name }}</div>
          <div class="extra-small">{{ profile.affiliation_date }}</div>
          <div class="extra-small text-secondary" *ngIf="profile.affiliation_status === 1">
            {{ profile.upgradation_date }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
